import { clsx } from 'clsx'

import { Typography } from 'components'

type Props = {
	title: string
	description: string
	color: 'product' | 'orange'
	href: string
	hrefAriaLabel: string
}

const colorClasses = {
	product: {
		borderColor: 'border-l-product',
		colorText: 'text-product'
	},
	orange: {
		borderColor: 'border-l-orange',
		colorText: 'text-orange'
	}
}

const HighlightCard = ({
	title,
	description,
	color,
	href,
	hrefAriaLabel
}: Props) => {
	const { borderColor, colorText: text } = colorClasses[color]

	return (
		<a
			aria-label={hrefAriaLabel}
			class={clsx(
				color,
				borderColor,
				'rounded-md border border-l-4 border-black-800 p-5 hover:bg-black-800'
			)}
			href={href}
			rel='noopener noreferrer'
			target='_blank'
		>
			<Typography
				class='mb-5 pr-4'
				color={text}
				text={title}
				variant='h2'
				weight='font-normal'
			/>

			<Typography
				class='mb-5'
				color='text-black-100'
				text={description}
				variant='text2'
			/>
		</a>
	)
}

export { HighlightCard }
